import LoanAccounts from '@/views/LoanSettings/LoanAccounts';
import LoanProducts from '@/views/LoanSettings/LoanProducts';
import { requiresLoanSettingsAccess } from './helpers';

export default [
  {
    path: '/loan-settings/accounts',
    name: 'LoanAccounts',
    component: LoanAccounts,
    beforeEnter: requiresLoanSettingsAccess,
    meta: { group: 'loanSettings', roles: ['ADMINISTRATOR'] },
  },
  {
    path: '/loan-settings/products',
    name: 'LoanProducts',
    component: LoanProducts,
    beforeEnter: requiresLoanSettingsAccess,
    meta: { group: 'loanSettings', roles: ['ADMINISTRATOR'] },
  },
];
